"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// credits to react-motion
exports.noWobble = { stiffness: 170, damping: 26 };
exports.gentle = { stiffness: 120, damping: 14 };
exports.wobbly = { stiffness: 180, damping: 12 };
exports.stiff = { stiffness: 210, damping: 20 };
exports.slowMo = { stiffness: 5, damping: 30 };
exports.default = {
    noWobble: exports.noWobble,
    gentle: exports.gentle,
    wobbly: exports.wobbly,
    stiff: exports.stiff,
    slowMo: exports.slowMo,
};
//# sourceMappingURL=presets.js.map